<template>
  <div class="log">
    <button
      @click.stop="dialog = false"
      @click="check()"
      title=""
      aria-label="Edit Driver Price"
      target="_blank"
      class="view-ass-btn view-ass-btn--driver-price"
      v-if="!hideTrigger"
      :disabled="processing || viewOnly == 'view'"
    >
      <v-icon small>edit</v-icon>
    </button>

    <v-dialog v-model="dialog" content-class="price-edit-dialog">
      <v-form
        ref="form"
        v-model="valid"
        :lazy-validation="lazy"
        onsubmit="return false;"
      >
        <v-card class="pe-card">
          <div class="pe-head">
            <span class="pe-head__icon"><v-icon>local_shipping</v-icon></span>
            <div class="pe-head__text">
              <strong>Edit driver price</strong>
              <span>Job {{ jobId }} · price per assignment</span>
            </div>
            <v-btn
              icon
              class="pe-head__close"
              :disabled="processing"
              @click.prevent="cancel()"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <v-progress-linear
            indeterminate
            color="orange"
            height="3"
            class="pe-progress"
            v-show="processing || loading"
          ></v-progress-linear>

          <div class="pe-body">
            <div class="pe-grid">
              <div class="pe-field">
                <span class="pe-label">Assignment *</span>
                <v-select
                  :items="AssignmentId"
                  v-model="x.ids"
                  @change="checkPrice(x.ids)"
                  :rules="[rules.required]"
                  class="pe-input"
                  hide-details
                ></v-select>
              </div>
              <div class="pe-field">
                <span class="pe-label">Driver price *</span>
                <v-text-field
                  v-model="x.paymentAmount"
                  type="number"
                  min="0"
                  :suffix="x.customerCurrency"
                  class="pe-input"
                  hide-details
                  @keyup.enter="addCharges(x.status)"
                ></v-text-field>
              </div>
            </div>
            <div class="pe-field">
              <span class="pe-label">Comments</span>
              <v-text-field
                v-model="x.comments"
                placeholder="Optional note for this change"
                class="pe-input"
                hide-details
              ></v-text-field>
            </div>
            <div v-if="haserror && x.error" class="pe-error">
              <v-icon small>error_outline</v-icon>
              <span>{{ x.error }}</span>
            </div>
          </div>

          <div class="pe-actions">
            <v-btn
              flat
              class="pe-btn pe-btn--ghost"
              :disabled="processing"
              @click="cancel()"
              >Cancel</v-btn
            >
            <v-btn
              flat
              class="pe-btn pe-btn--primary"
              :disabled="processing"
              @click="addCharges(x.status)"
              >Save price</v-btn
            >
          </div>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import ErrorBox from "@/components/Common/ErrorBox";
import SuccessDialog from "@/components/Common/SuccessDialog";
import Loading from "vue-loading-overlay";
import {
  editDriverPrice,
  assignmentForEditDriverPrice,
} from "@/constants/api-urls.js";
import { EventBus } from "../../event-bus.js";
import { StorageKeys, Currencies } from "../../constants/constants";
import CustomerCurrency from "@/components/Common/CustomerCurrency";
export default {
  data() {
    return {
      creditLimitError: "",
      valid: true,
      lazy: false,
      AssignmentId: [],
      options: {
        color: "#ffc04c",
        width: 400,
        zIndex: 200,
      },
      dialog1: false,
      operationName: "",
      x: {
        error: null,
        jobPrice: null,
        customerCurrency: null,
        comments: null,
        ids: null,
        paymentAmount: null,
        advanceRequestedState: null,
        status: null,
      },
      amount: null,
      items: [],
      currencies: [],
      processing: false,
      reason: "",
      dialog: false,
      disStatus: false,
      haserror: false,
      loading: false,
      rules: {
        required: (value) => !!value || "This field is required.",
        emailRules: (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/.test(v) ||
          "E-mail must be valid",
        countryCode: (v) =>
          /^(\+?\d{1,3}|\d{1,4})$/.test(v) ||
          "Please Enter Valid Country Code.",
        phoneNumber: (v) =>
          /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/.test(v) ||
          "Please Enter Valid Mobile No.",
        number: (v) => /^[0-9]*$/.test(v) || "Please Enter Valid Price",
      },
    };
  },
  props: ["jobId", "detail", "subJobDetail", "working", "viewOnly", "hideTrigger"],

  created() {
    // this.assigments();
    if (this.$props.working) {
      if (this.$props.working == "UAE") {
        this.x.customerCurrency == "AED";
      }
      if (this.$props.working == "PAK") {
        this.x.customerCurrency == "PKR";
      }
      if (this.$props.working == "KSA") {
        this.x.customerCurrency == "SAR";
      }
      if (this.$props.working == "UAE LA") {
        this.x.customerCurrency == "AED";
      }
      if (this.$props.working == "OMAN") {
        this.x.customerCurrency == "OMR";
      }
    }
    // this.getActivityLog();
    this.x.error = null;
    this.haserror = false;
    this.currencies = Currencies;
    // this.x.customerCurrency = this.detail.customerCurrency;
  },
  components: {
    ErrorBox,
    CustomerCurrency,
    SuccessDialog,
    Loading,
  },
  methods: {
    checkPrice(id) {
      this.AssignmentId.forEach((e) => {
        if (e.value == id) {
          this.x.paymentAmount = e.price;
          this.x.status = e.status;
          this.x.advanceRequestedState = e.advanceRequestedState;
          return;
        }
      });
    },
    assigments() {
      this.AssignmentId = [];
      this.truckPrefix = this.$props.truckprefix;
      this.truckNumber = this.$props.truckNo;
      this.loading = true;
      const data = {
        jobId: this.$route.params.id,
        tabOrder: this.subJobDetail.tabOrder
          ? this.subJobDetail.tabOrder.toString()
          : "1",
      };

      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      const { apiUrl } = this.constants;
      this.axios
        .post(`${apiUrl}${assignmentForEditDriverPrice}`, data, config)
        .then(
          (response) => {
            const { data } = response.data;
            response.data.data.forEach((e) => {
              console.log(e, "------------------editresponse");
              this.AssignmentId.push({
                value: e.assignmentId,
                text: e.assignmentId,
                price: e.paymentAmount,
                status: e.assignmentStatus,
                advanceRequestedState: e.advanceRequestedState,
              });
            });
            this.x.ids = this.AssignmentId[0].text;
            console.log(this.AssignmentId[0].status);
            this.x.status = this.AssignmentId[0].status;
            this.x.advanceRequestedState =
              this.AssignmentId[0].advanceRequestedState;
            console.log(this.AssignmentId);
            console.log(
              this.AssignmentId[0].advanceRequestedState,
              "----advancerequested"
            );
            this.x.paymentAmount = this.AssignmentId[0].price;
            console.log(this.x.paymentAmount);
            this.loading = false;
          },
          (error) => {
            this.error = error.response.data.message;
            this.dailog = false;
            this.loading = false;
          }
        );
    },
    cancel() {
      this.dialog = false;
      this.dialog1 = false;
      this.x.paymentAmount = null;
      this.x.comments = null;
      if (this.$refs.form) this.$refs.form.resetValidation();
      this.x.ids = null;
    },
    async check() {
      this.processing = true;
      this.operationName = "edit_driver_price";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.open();
      } else {
        this.processing = false;
        return;
      }
    },
    closeMessage() {
      this.processing = false;
      this.x.success = false;
      this.isEmail = true;
    },
    open() {
      console.log(this.subJobDetail.perAssignmentPrice);
      this.assigments();
      this.dialog = true;
      this.processing = false;
      this.x.error = null;
      this.haserror = false;
      this.currencies = Currencies;
      this.x.paymentAmount = null;
      this.x.customerCurrency = this.detail.customerCurrency;
    },
    async addCharges(status) {
      console.log(this.x.advanceRequestedState, "----status");
      this.processing = true;
      this.operationName = "edit_driver_price";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        if (!navigator.onLine) {
          this.processing = false;
          this.x.error = "Please check your internet connection";
          this.haserror = true;
          setTimeout(() => {
            this.x.error = "";
          }, 3000);
          return;
        }
        this.processing = true;
        this.haserror = false;
        if (!this.x.ids) {
          this.processing = false;
          this.x.error = "Please select assignment id.";
          this.haserror = true;
          setTimeout(() => {
            this.x.error = "";
          }, 1000);
          return;
        }
        console.log(this.subJobDetail.perAssignmentPrice);
        if (
          Number(this.x.paymentAmount) >
          Number(this.subJobDetail.perAssignmentPrice)
        ) {
          this.processing = false;
          this.x.error = `Driver price should be less than the assignment amount ${this.subJobDetail.perAssignmentPrice} ${this.x.customerCurrency}`;
          this.haserror = true;
          setTimeout(() => {
            this.x.error = "";
          }, 3000);
          return;
        }

        if (this.x.paymentAmount == null || this.x.paymentAmount <= 0) {
          this.processing = false;
          this.x.error = "Please provide payment amount above 0";
          this.haserror = true;
          setTimeout(() => {
            this.x.error = "";
          }, 1000);
          return;
        }

        // if (!this.x.paymentAmount.match(/^[0-9]*$/)) {
        //   this.x.error = "Please enter valid price.";
        //   this.haserror = true;
        //   return;
        // }
        // if (this.x.paymentAmount == 0) {
        //   this.processing = false;
        //   this.x.error = "Please enter valid price.";
        //   this.haserror = true;
        //   setTimeout(() => {
        //     this.x.error = "";
        //   }, 1000);
        //   return;
        // }
        console.log(this.x.advanceRequestedState, "------advancerequested");
        if (this.x.paymentAmount == 0 && this.x.advanceRequestedState) {
          this.processing = false;
          this.x.error = "Please cancel advance then  you fill 0 amount";
          this.haserror = true;
          return;
        }

        if (this.x.paymentAmount >= 1000000000000) {
          this.processing = false;
          this.x.error = "Please enter amount less than 1000000000000";
          this.haserror = true;
          setTimeout(() => {
            this.x.error = "";
          }, 10000);
          return;
        }

        // if (this.x.paymentAmount) {
        //   var value = /^[0-9]*$/.test(this.x.paymentAmount);
        //   if (!value) {
        //     this.processing = false;
        //     this.x.error = "Please enter valid price.";
        //     this.haserror = true;
        //     setTimeout(() => {
        //       this.x.error = "";
        //     }, 1000);
        //     return;
        //   }
        // }

        if (!this.x.customerCurrency || this.x.customerCurrency == undefined) {
          this.processing = false;
          this.x.error = "Please select the currency.";
          this.haserror = true;
          setTimeout(() => {
            this.x.error = "";
          }, 1000);
          return;
        }

        let url = editDriverPrice;
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };

        var body = {
          assignmentId: this.x.ids.toString(),
          paymentCurrency: this.x.customerCurrency,
          paymentAmount: this.x.paymentAmount.toString(),
        };
        if (this.x.comments) {
          body.comments = this.x.comments;
        }

        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            var amount = this.amount;
            //   this.$eventBus.$emit("additional-charges-added", amount);
            this.$eventBus.$emit("refresh-job");
            this.amount = null;
            this.x.paymentAmount = null;
            this.processing = false;
            this.x.success = true;
            this.cancel();
            this.x.error = null;
            this.haserror = false;
          },
          (error) => {
            this.processing = false;
            this.dialog = true;
            this.haserror = true;
            this.x.error = error.response.data.message;
          }
        );
      } else {
        this.processing = false;
        return;
      }
    },
  },
};
</script>
<style scoped>
.break_long_text {
  word-break: break-all;
  word-break: break-word;
  hyphens: auto;
}
.user {
  padding: 10px;
}

.comments-view .v-toolbar {
  width: 100%;
  /* margin-left: 25%; */
}
.v-toolbar--fixed {
  position: inherit;
}
.assign-driver-btn {
  text-decoration: none;
  color: #ffffff;
  background-color: #bebebe;
  border: 2px solid grey;
  padding: 2px 5px;
  border-radius: 5px;
}

.view-ass-btn {
  text-decoration: none;
  color: #ffffff;
  background-color: #c87ffe;
  border: 2px solid indigo;
  padding: 2px 5px;
  border-radius: 5px;
}

.view-ass-btn--driver-price {
  align-items: center !important;
  background: #fff7ed !important;
  border: 1px solid #fed7aa !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  color: #a85510 !important;
  cursor: pointer;
  display: inline-flex !important;
  height: 30px !important;
  justify-content: center !important;
  line-height: 1 !important;
  margin: 0 !important;
  min-height: 30px !important;
  min-width: 30px !important;
  opacity: 1 !important;
  padding: 0 !important;
  text-indent: 0 !important;
  visibility: visible !important;
  width: 30px !important;
}

.view-ass-btn--driver-price .v-icon {
  color: currentColor !important;
  font-size: 17px !important;
}

.view-ass-btn--driver-price:hover:not([disabled]) {
  background: #ffedd5 !important;
  border-color: #fdba74 !important;
  color: #8a420b !important;
}

.oms-job-price-dialog-card {
  border-radius: 10px !important;
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.18) !important;
  overflow: hidden;
}

.oms-job-price-dialog-card .v-toolbar {
  background: #fff7ed !important;
  border-bottom: 1px solid #fed7aa;
  color: #172033 !important;
}

.oms-job-price-dialog-card .v-toolbar__title {
  color: #172033 !important;
  font-size: 15px;
  font-weight: 900;
}

.oms-job-price-dialog-card .v-card__text {
  background: #ffffff;
  padding: 12px !important;
}

.oms-job-price-dialog-card .v-card__actions {
  border-top: 1px solid #e4e7ec;
  padding: 10px 12px !important;
}

.oms-job-price-dialog-card .v-card__actions .v-btn {
  border-radius: 7px !important;
  box-shadow: none !important;
  font-weight: 900;
  letter-spacing: 0;
  text-transform: none;
}
</style>
